module.exports = __webpack_public_path__ + "img/standard-set.4a2f06dd.jpg";